import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';


export default function CreateTickets() {
  return (
    <>
      {/* Form Input Groups: Prepend Icon */}
      <div className="space-y-6 dark:text-gray-100">
        {/* Input with Icon prepend (small) */}
        <div className="space-y-1">
          <label htmlFor="prepend_small" className="font-medium">
            Title
            {/* <span className="font-normal text-gray-500 dark:text-gray-400">
              (small input)
            </span> */}
          </label>
            <input
              type="text"
              id="prepend_small"
              name="prepend_small"
              className="block w-full rounded-lg border border-gray-200 py-2 pl-10 pr-3 text-sm leading-5 placeholder-gray-500 focus:border-primary-500 focus:ring focus:ring-primary-500 focus:ring-opacity-50 dark:border-gray-600 dark:bg-gray-800 dark:placeholder-gray-400 dark:focus:border-primary-500"
            />
       
        </div>
        {/* END Input with Icon prepend (small) */}

        <div className="space-y-1">
        {/* Radios Inline */}
        <div className="space-y-2">
          <div className="font-medium">Ticket Type</div>
          <div className="mt-2">
            <label className="inline-flex items-center">
              <input
                type="radio"
                id="radio1"
                name="group_radio"
                className="size-4 border border-gray-200 text-primary-500 focus:border-primary-500 focus:ring focus:ring-primary-500 focus:ring-opacity-50 dark:border-gray-600 dark:bg-gray-800 dark:ring-offset-gray-900 dark:checked:border-transparent dark:checked:bg-primary-500 dark:focus:border-primary-500"
                defaultChecked
              />
              <span className="ml-2">Bug</span>
            </label>
            <label className="ml-6 inline-flex items-center">
              <input
                type="radio"
                id="radio2"
                name="group_radio"
                className="size-4 border border-gray-200 text-primary-500 focus:border-primary-500 focus:ring focus:ring-primary-500 focus:ring-opacity-50 dark:border-gray-600 dark:bg-gray-800 dark:ring-offset-gray-900 dark:checked:border-transparent dark:checked:bg-primary-500 dark:focus:border-primary-500"
              />
              <span className="ml-2">Feature Request</span>
            </label>
          </div>
        </div>
        </div>

        {/* Input with Icon prepend (normal) */}
        {/* Textarea */}
        <div className="space-y-1">
          <label htmlFor="details" className="font-medium">
            Description
          </label>
          <textarea
            id="details"
            name="details"
            rows={4}
            placeholder="Enter further details including parking place ID, sign ID."
            className="block w-full rounded-lg border border-gray-200 px-3 py-2 leading-6 placeholder-gray-500 focus:border-primary-500 focus:ring focus:ring-primary-500 focus:ring-opacity-50 dark:border-gray-600 dark:bg-gray-800 dark:placeholder-gray-400 dark:focus:border-primary-500"
            defaultValue={""}
          />
        </div>
        {/* END Textarea */}

        {/* END Input with Icon prepend (normal) */}

        {/* Input with Icon prepend (large) */}
        <div className="space-y-1">
          <label htmlFor="prepend_large" className="font-medium">
            Primary Contact
          </label>
          <div className="relative">
            <div className="pointer-events-none absolute inset-y-0 left-0 my-px ml-px flex w-12 items-center justify-center rounded-l-lg text-gray-500 dark:text-gray-400">
              <svg
                className="hi-mini hi-inbox inline-block size-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M1 11.27c0-.246.033-.492.099-.73l1.523-5.521A2.75 2.75 0 015.273 3h9.454a2.75 2.75 0 012.651 2.019l1.523 5.52c.066.239.099.485.099.732V15a2 2 0 01-2 2H3a2 2 0 01-2-2v-3.73zm3.068-5.852A1.25 1.25 0 015.273 4.5h9.454a1.25 1.25 0 011.205.918l1.523 5.52c.006.02.01.041.015.062H14a1 1 0 00-.86.49l-.606 1.02a1 1 0 01-.86.49H8.236a1 1 0 01-.894-.553l-.448-.894A1 1 0 006 11H2.53l.015-.062 1.523-5.52z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <input
              type="text"
              id="prepend_large"
              name="prepend_large"
              placeholder="john.doe@example.com"
              className="block w-full rounded-lg border border-gray-200 py-3 pl-12 pr-5 leading-6 placeholder-gray-500 focus:border-primary-500 focus:ring focus:ring-primary-500 focus:ring-opacity-50 dark:border-gray-600 dark:bg-gray-800 dark:placeholder-gray-400 dark:focus:border-primary-500"
            />
          </div>
        </div>
        {/* END Input with Icon prepend (large) */}


        <div className="space-y-1">
          {/* File Input */}
          <label className="block">
            <span className="sr-only">Choose profile photo</span>
            <input
              type="file"
              id="photo"
              name="photo"
              className="block w-full text-sm text-gray-500 file:mr-4 file:rounded file:border-0 file:bg-primary-50 file:px-4 file:py-2 file:text-sm file:font-semibold file:text-primary-700 hover:file:bg-primary-100 dark:text-gray-400 dark:file:bg-primary-200 dark:file:text-primary-800 dark:hover:file:bg-primary-300"
            />
          </label>
        {/* END File Input */}
        </div>

    
        {/* END Input with Icon prepend alt (large) */}
      </div>
      {/* END Form Input Groups: Prepend Icon */}
    </>
  );
}
